import { CategoryType } from "enums";
import { CategoryModel } from "models";

/**
 * リストの中から該当するIDのオブジェクトを探して返します。
 * @param id
 * @param list
 * @returns
 */
export function pick(
  id: string,
  list: CategoryModel[] | null
): CategoryModel | null {
  if (!list) {
    return null;
  }
  for (let c of list) {
    if (c.id === id) {
      return c;
    } else if (c.list) {
      const tmp = pick(id, c.list);
      if (tmp) {
        return tmp;
      }
    }
  }
  return null;
}


/**
 * リストの中から該当するIDのオブジェクトを探して返します。
 * @param id
 * @param list
 * @param type
 * @returns
 */
export function pickCategory(
  id: string,
  list: CategoryModel[] | null,
  type = CategoryType.LARGE
): CategoryModel | null {
  if (!list) {
    return null;
  }
  for (let c of list) {
    if (c.id === id && c.type === type) {
      return c;
    } else if (c.list) {
      const tmp = pickCategory(id, c.list, type);
      if (tmp) {
        return tmp;
      }
    }
  }
  return null;
}